import './App.css';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from "react-hot-toast";
import ScrollToTop from './helpers/ScrollToTop';

function App() {
  const location = useLocation();
  const isAdminPanel = location.pathname.startsWith('/admin-panel');

  return (
    <>
      <ScrollToTop />
      {!isAdminPanel && <Header />}

      <main className='bg-[#f5f7f5]'>
        <Outlet />
      </main>

      {!isAdminPanel && <Footer />}

      {/* Toast Notifications */}
     <Toaster position="top-center" toastOptions={{ duration: 3000 }} />

    </>
  );
}

export default App;
